import Component from '@glimmer/component'

interface Signature {
  Element: HTMLDivElement
  Args: {
    tags?: string
  }
}

const TAG_COLORS: Record<string, string> = {
  'Imaginative Texts': 'bg-[#C65224]',
  'Informative Texts': 'bg-oceany-blue-350',
  'Persuasive Texts': 'bg-pink-300',
}

export class ActivityTags extends Component<Signature> {
  get activityTags() {
    const tags = this.args.tags
    if (!tags) return []
    return tags
      .split(',')
      .map((tag) => tag.trim())
      .filter((tag) => !tag.toLowerCase().includes('grade'))
      .sort((a, b) => {
        const aIsMain = a in TAG_COLORS
        const bIsMain = b in TAG_COLORS
        if (aIsMain && !bIsMain) return -1
        if (!aIsMain && bIsMain) return 1
        return a.localeCompare(b)
      })
  }

  tagBadgeColor = (tag: string): string => {
    return TAG_COLORS[tag] ?? 'bg-[#018950]'
  }

  <template>
    <div ...attributes data-test-activity-tags>
      {{#each this.activityTags as |tag|}}
        <span
          class="rounded-full px-3 py-1 text-sm text-white {{this.tagBadgeColor tag}}"
          data-test-tag-badge
        >{{tag}}</span>
      {{/each}}
    </div>
  </template>
}

export default ActivityTags
